class ImageScroll extends HTMLElement {
    connectedCallback() {
        this.querySelectorAll(".faq-item-text").forEach(panel => {
            panel.style.display = "block";          // IMPORTANT si CSS met display:none
            panel.style.overflow = "hidden";
            panel.style.maxHeight = "0px";
            panel.style.transition = "max-height 420ms ease";
            panel.dataset.open = "false";
        });

        this.querySelectorAll(".faq-item-title").forEach((btn) => {
            btn.addEventListener("click", this.toggleFaqItem.bind(this));
        });

        this.onScroll();
        window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        window.addEventListener('resize', this.syncOpenHeights.bind(this));
    }

    syncOpenHeights() {
        this.querySelectorAll('.faq-item-text[data-open="true"]').forEach(p => {
            p.style.maxHeight = p.scrollHeight + "px";
        });
    }

    openPanel(panel) {
        panel.style.maxHeight = panel.scrollHeight + "px";
        panel.dataset.open = "true";
    }

    closePanel(panel) {
        panel.style.maxHeight = "0px";
        panel.dataset.open = "false";
    }

    toggleFaqItem(e) {
        const title = e.currentTarget;
        const item = title.closest(".image-text-scroll__item");
        const panel = item.querySelector(".faq-item-text");

        title.querySelector(".faq-close")?.classList.toggle("faq-display-none");
        item.classList.toggle("faq-item-active"); // drapeau "manuel"

        if (panel.dataset.open === "true") {
            this.closePanel(panel);
        } else {
            this.openPanel(panel);
        }
    }

    onScroll() {
        const items = Array.from(this.querySelectorAll('.image-text-scroll__item'));
        const vh = window.innerHeight;
        const scrollY = window.scrollY;

        const tops = items.map(el => el.getBoundingClientRect().top + scrollY);
        const mids = tops.map(top => top - vh * 0.5);
        const starts = tops.map((top, i) => (i === 0 ? top - vh * 0.75 : mids[i - 1]));
        const pcts = items.map((_, i) => {
            const pct = (scrollY - starts[i]) / (mids[i] - starts[i]);
            return Math.max(0, Math.min(1, pct));
        });

        items.forEach((item, i) => {
            const badge = item.querySelector('.image-text-scroll__item-span');
            const content = item.querySelector('.scroll__effect .content');
            const panel = item.querySelector('.faq-item-text');

            const shouldBeActive = i === 0 ? pcts[0] > 0 : pcts[i - 1] >= 1;

            if (badge) badge.classList.toggle('active', shouldBeActive);

            if (!item.classList.contains('faq-item-active') && panel) {
                if (shouldBeActive) this.openPanel(panel);
                else this.closePanel(panel);
            }

            if (content) content.style.height = `${pcts[i] * 100}%`;
        });
    }
}

customElements.define('image-text-scroll', ImageScroll);
